<script setup>
import { computed } from 'vue';
import AdvancedComparisonForProduct from 'components/competitor-app-v2/advanced-comparisons/AdvancedComparisonForProduct.vue';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  showIndustry: {
    type: Boolean,
    required: false,
    default: false,
  },
  fadedBgColor: {
    type: String,
    required: false,
    default: '#ebebeb'
  },
  showHeadline: {
    type: Boolean,
    required: false,
    default: false,
  }
});

const comparisons = computed(() => props.product.advancedComparisons);

const hasComparisons = computed(() => comparisons.value?.length > 0);
</script>

<template>
  <div v-if="hasComparisons">
    <h2
      v-if="showHeadline"
      class="ce-productDetailsHeadline">
      {{ $t('competitorApp.v2.advancedComparisons.forProduct.headline') }}
    </h2>

    <table>
      <tbody>
        <tr>
          <th>
            {{ $t('competitorApp.v2.advancedComparisons.forProduct.name') }}
          </th>
          <th v-if="showIndustry">
            {{ $t('competitorApp.v2.advancedComparisons.forProduct.industry') }}
          </th>
          <th>
            {{ $t('competitorApp.v2.advancedComparisons.forProduct.components') }}
          </th>
        </tr>
        <AdvancedComparisonForProduct
          v-for="(comparison, index) in comparisons"
          :style="(index + 1) % 2 ? 'background: ' + fadedBgColor : ''"
          :key="comparison.id"
          :comparison="comparison"
          :product="product"
          :show-industry="showIndustry" />
      </tbody>
    </table>
  </div>
</template>

<style lang="less" scoped>
@import (reference) '~styles/includes/base';

table {
  border-spacing: 0;
  width: 100%;

  th {
    text-align: left;
    padding: @space-2;
    line-height: 1.5;
  }
}
</style>
